<template>
  <div class="industry-report-container">
    <div class="report-header">
      <div class="report-title-section">
        <div class="report-tag">五大行业经营情况</div>
        <div class="report-title">五大行业经营情况</div>
      </div>
      <div class="report-info">
        <div class="report-date">更新至 2026-07-24</div>
        <button class="report-action">编辑报告</button>
      </div>
    </div>

    <div class="stat-cards">
      <div class="stat-card">
        <div class="stat-value">346,258 万</div>
        <div class="stat-label">H1 实际收入</div>
      </div>
      <div class="stat-card">
        <div class="stat-value">338,884 万</div>
        <div class="stat-label">H1 目标收入</div>
      </div>
      <div class="stat-card">
        <div class="stat-value green">97.9%</div>
        <div class="stat-label">整体目标完成率</div>
      </div>
      <div class="stat-card warning">
        <div class="stat-value">17,020 万 / 1 个</div>
        <div class="stat-label">重点关差行业</div>
      </div>
    </div>

    <div class="report-section">
      <div class="section-header">
        <div class="section-title">五大行业对比及差距分析</div>
      </div>
      <div class="section-table">
        <table>
          <thead>
            <tr>
              <th>五大行业</th>
              <th>对比指标</th>
              <th>计算口径</th>
              <th>完成情况</th>
              <th>同比变化</th>
              <th>差距分析</th>
              <th>阶段</th>
              <th>差距原因</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="industry-name">机械装备</td>
              <td>目标达成率</td>
              <td>实际/目标（%）</td>
              <td class="completed">100.4%</td>
              <td>1,220</td>
              <td>2.3% 超额完成</td>
              <td></td>
              <td class="reason-green">基本达成</td>
            </tr>
            <tr>
              <td class="industry-name">汽车行业</td>
              <td>目标达成率</td>
              <td>实际/目标（%）</td>
              <td class="completed highlight">107.2%</td>
              <td>1,190</td>
              <td>7.7% 超额完成</td>
              <td></td>
              <td class="reason-green">达成</td>
            </tr>
            <tr>
              <td class="industry-name">泛半导体</td>
              <td>目标达成率</td>
              <td>实际/目标（%）</td>
              <td class="warning">97.6%</td>
              <td>2,850</td>
              <td>2.4% 未达标</td>
              <td></td>
              <td class="reason-yellow">基本达成</td>
            </tr>
            <tr>
              <td class="industry-name">消费电子</td>
              <td>目标达成率</td>
              <td>实际/目标（%）</td>
              <td class="completed highlight">107.4%</td>
              <td>1,640</td>
              <td>7.4% 超额完成</td>
              <td></td>
              <td class="reason-green">达成</td>
            </tr>
            <tr>
              <td class="industry-name">流程行业</td>
              <td>目标达成率</td>
              <td>实际/目标（%）</td>
              <td class="danger">89.4%</td>
              <td>1,960</td>
              <td>10.6% 未达标</td>
              <td></td>
              <td class="reason-red">差距</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="report-footer">
      <div class="footer-note">注：数据截至 2026 年 6 月 30 日，部分数据为预估。</div>
      <div class="footer-action">查看更多详情</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IndustryReport'
}
</script>

<style scoped>
.industry-report-container {
  padding: 20px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e8ecf0;
  min-height: 100%;
}

.report-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}

.report-title-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.report-tag {
  font-size: 12px;
  color: #4A5FF3;
  font-weight: 600;
}

.report-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2937;
}

.report-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.report-date {
  font-size: 12px;
  color: #94a3b8;
}

.report-action {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 11px;
  color: #4A5FF3;
  background: #f0f4ff;
  border: 1px solid #dde4f0;
  cursor: pointer;
}

.stat-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}

.stat-card {
  padding: 16px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e8ecf0;
}

.stat-card.warning {
  background: #fff7ed;
  border-color: rgba(217, 130, 19, 0.2);
}

.stat-value {
  font-size: 20px;
  font-weight: 800;
  color: #1f2937;
  margin-bottom: 4px;
}

.stat-value.green {
  color: #0aa66a;
}

.stat-label {
  font-size: 11px;
  color: #64748b;
}

.report-section {
  margin-bottom: 20px;
}

.section-header {
  margin-bottom: 12px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.section-table {
  overflow-x: auto;
  border-radius: 12px;
  border: 1px solid #e8ecf0;
}

.section-table table {
  width: 100%;
  border-collapse: collapse;
}

.section-table th {
  padding: 10px 12px;
  text-align: left;
  font-size: 11px;
  color: #64748b;
  font-weight: 600;
  background: #f8fafc;
  border-bottom: 2px solid #e8ecf0;
}

.section-table td {
  padding: 10px 12px;
  font-size: 12px;
  color: #475569;
  border-bottom: 1px solid #f1f5f9;
}

.industry-name {
  font-weight: 600;
  color: #1f2937;
}

.completed {
  color: #0aa66a;
  font-weight: 600;
}

.completed.highlight {
  background: #f0fdf4;
}

.warning {
  color: #d98213;
  font-weight: 600;
}

.danger {
  color: #e54b3d;
  font-weight: 600;
  background: #fef2f2;
}

.reason-green {
  color: #0aa66a;
  font-weight: 600;
}

.reason-yellow {
  color: #d98213;
  font-weight: 600;
}

.reason-red {
  color: #e54b3d;
  font-weight: 600;
}

.report-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
}

.footer-note {
  font-size: 11px;
  color: #94a3b8;
}

.footer-action {
  font-size: 12px;
  color: #4A5FF3;
  font-weight: 600;
  cursor: pointer;
}
</style>
